import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import { Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
// import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link, useParams } from "react-router";
import { $api, type components } from "../../helper";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";
// import FilterSearch from "../../components/filter/FilterSearch";

export default function ListTransportation() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const [id, setId] = useState("");
  const params = useParams();
  const { data, isPending, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/branch/details/",
    {
      params: {
        query: {
          branch_u_id: params.id ?? "",
          detail_type: 2,
        },
      },
    },
  );
  const removeCategory = $api.useMutation(
    "delete",
    "/site-api/v1/branch/details/",
  );
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("لیست حمل و نقل عمومی");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteBranchDetailsItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "وسیله نقلیه",
      dataIndex: "title",
      key: "title",
      render: (value, record) => {
        return record.transport_type === 1 ? "اتوبوس" : "مترو";
      },
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            to={{
              pathname: `/add-transportation/${params.id}`,
              search: "?u_id=" + record.u_id,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: `/add-transportation/${params.id}`,
              search: "?u_id=" + record.u_id,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
                        icon="solar:trash-bin-trash-linear"
                        className="text-error-500!"
                        onClick={() => {
                          setId(record.u_id);
                          setIsOpen(true);
                        }}
                      /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={removeCategory.isPending}
        title="حذف از حمل و نقل عمومی ؟"
        description="حذف این حمل و نقل باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          removeCategory.mutate(
            {
              params: {
                query: {
                  detail_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                setIsOpen(false);
                notify.success(data.message);
                setId("");
                refetch();
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <div className="w-full flex justify-between sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <CustomBreadcrumb
          items={[
            {
              title: "لیست شعب",
              href: "/branch-list",
            },
            {
              title: "لیست حمل و نقل",
            },
          ]}
        />
        <Link to={`/add-transportation/${params.id}`} className="button-style">
          ایجاد مسر حمل و نقل عمومی
        </Link>
      </div>

      <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
        <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SiteBranchDetailsItem"]>
            columns={columns}
            dataSource={data?.data}
            loading={isPending}
            className="col-span-1!"
            scroll={{ x: "max-content" }}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
